import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { setLoading } from '../global';
import { bearerAuth } from '../auth';

export const startVerify = createAsyncThunk(
    'Verify/start',
    ({jwtToken, verifierTemplateKey}: { jwtToken: string | undefined, verifierTemplateKey: string }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };

        return axios.post(`/verify/${verifierTemplateKey}`, {}, config)
            .then(response => response.data)
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);

export const checkVerifyStatus = createAsyncThunk(
    'Verify/checkStatus',
    ({jwtToken, sessionId}: { jwtToken: string | undefined, sessionId: string }) => {
        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };

        return axios.get(`/verify/status/${sessionId}`, config)
            .then(response => response.data);
    },
);
